const ANIMATIONS_BASE = 'https://lluvykhqgdnbfobjixbj.supabase.co/storage/v1/object/public/avatar-animations';

// ═══ Clipes MP-rigged — retargetados para metaperson_2.0 (09/08) ═══════════
//
// MANIFESTO da allowlist /mp/ da PR #451: o AvatarCore só deixa clipe externo
// tocar em avatar de catálogo/gerado quando a URL vive sob
// /avatar-animations/mp/ (src/features/avatar/core/animationClipPolicy.ts).
// Este objeto é a ÚNICA porta de endereçamento desses clipes — call site pede
// por CHAVE (getMpAnimationUrl), nunca monta URL /mp/ na mão. É o que mantém
// o CI no circuito de uma fronteira que vive no Storage: o teste
// (src/test/mpAnimationLibrary.test.ts) pina as 47 chaves, os dois pools, o
// predicado da #451 sobre cada URL e — desde 10/08 — o CAMINHO COMPLETO de
// cada uma contra um fixture de realidade (src/test/fixtures/mpClipObjects.ts).
//
// A conferência de 09/08 dizia "47/47, nomes 1:1 com as chaves" e estava
// certa — e não bastava: ela comparou NOME DE ARQUIVO, e o defeito estava no
// DIRETÓRIO. Os 47 objetos vivem em `mp/final/`, não em `mp/`, e por onze dias
// as 47 URLs deste manifesto apontaram para 404 com o teste verde.
//
// As CHAVES são os nomes de arquivo sem .glb, kebab-case, de propósito:
// grep de uma chave acha o asset e vice-versa.
//
// Origem preservada: ActorCore / Character Creator → MetaPerson (scripts/retarget-all.sh).
// O carregador externo aceita somente GLB; não há fallback ou biblioteca Mixamo.
// Nenhuma animação externa é escolhida automaticamente para MetaPerson.
//
// ⚠ LOCOMOÇÃO: o AvatarCore strippa hips.position de todo clipe externo (os
// clipes "moving*" não deslocam o modelo) e a cena não tem chão nem shadow
// catcher — locomoção visível é decisão futura, com root motion e piso.
// `mp/final` — o diretório REAL dos 47 objetos, medido em storage.objects
// (10/08): 0 objetos em `mp/<x>.glb`, 47 em `mp/final/<x>.glb`, e `final` é a
// única subpasta sob `mp/`. A allowlist da #451 (`/\/avatar-animations\/mp\//i`,
// animationClipPolicy.ts:24) continua casando: o segmento que ela procura é
// prefixo de `mp/final/`. Verificado rodando o predicado, não por leitura.
const MP_ANIMATIONS_BASE = `${ANIMATIONS_BASE}/mp/final`;

export const MP_ANIMATION_LIBRARY = {
  // ── PARADOS (19) ──────────────────────────────────────────────────────────
  'basic-move-f-idle':         `${MP_ANIMATIONS_BASE}/basic-move-f-idle.glb`,
  'basic-move-m-idle-462259':  `${MP_ANIMATIONS_BASE}/basic-move-m-idle-462259.glb`,
  'chat-calm-f':               `${MP_ANIMATIONS_BASE}/chat-calm-f.glb`,
  'chat-cheer-m':              `${MP_ANIMATIONS_BASE}/chat-cheer-m.glb`,
  'chat-listen-f':             `${MP_ANIMATIONS_BASE}/chat-listen-f.glb`,
  'chat-passion-f':            `${MP_ANIMATIONS_BASE}/chat-passion-f.glb`,
  'chat-passion-m':            `${MP_ANIMATIONS_BASE}/chat-passion-m.glb`,
  'chat-propose-m':            `${MP_ANIMATIONS_BASE}/chat-propose-m.glb`,
  'chat-relax-f':              `${MP_ANIMATIONS_BASE}/chat-relax-f.glb`,
  'chat-relax-m':              `${MP_ANIMATIONS_BASE}/chat-relax-m.glb`,
  'chat-response-f':           `${MP_ANIMATIONS_BASE}/chat-response-f.glb`,
  'chat-talkandlaugh-f':       `${MP_ANIMATIONS_BASE}/chat-talkandlaugh-f.glb`,
  'chat-talkandlaugh-m':       `${MP_ANIMATIONS_BASE}/chat-talkandlaugh-m.glb`,
  'discuss-passion-f':         `${MP_ANIMATIONS_BASE}/discuss-passion-f.glb`,
  'discuss-passion-m':         `${MP_ANIMATIONS_BASE}/discuss-passion-m.glb`,
  'discuss-query-m':           `${MP_ANIMATIONS_BASE}/discuss-query-m.glb`,
  'discuss-respond-f':         `${MP_ANIMATIONS_BASE}/discuss-respond-f.glb`,
  'discuss-whisper-f':         `${MP_ANIMATIONS_BASE}/discuss-whisper-f.glb`,
  'discuss-whisper-m':         `${MP_ANIMATIONS_BASE}/discuss-whisper-m.glb`,
  // ── ANDANDO (28) — locomoção, ver aviso de hips.position acima ────────────
  'movingchat-lookup-f':       `${MP_ANIMATIONS_BASE}/movingchat-lookup-f.glb`,
  'movingchat-lookup-m':       `${MP_ANIMATIONS_BASE}/movingchat-lookup-m.glb`,
  'movingchat-met-f':          `${MP_ANIMATIONS_BASE}/movingchat-met-f.glb`,
  'movingchat-met-m':          `${MP_ANIMATIONS_BASE}/movingchat-met-m.glb`,
  'movingchat-relax-f':        `${MP_ANIMATIONS_BASE}/movingchat-relax-f.glb`,
  'movingchat-relax-m':        `${MP_ANIMATIONS_BASE}/movingchat-relax-m.glb`,
  'movingchat-strolling-f':    `${MP_ANIMATIONS_BASE}/movingchat-strolling-f.glb`,
  'movingchat-strolling-m':    `${MP_ANIMATIONS_BASE}/movingchat-strolling-m.glb`,
  'movingchat-surroundings-f': `${MP_ANIMATIONS_BASE}/movingchat-surroundings-f.glb`,
  'movingchat-surroundings-m': `${MP_ANIMATIONS_BASE}/movingchat-surroundings-m.glb`,
  'movingdiscuss-calm-f':      `${MP_ANIMATIONS_BASE}/movingdiscuss-calm-f.glb`,
  'movingdiscuss-calm-m':      `${MP_ANIMATIONS_BASE}/movingdiscuss-calm-m.glb`,
  'movingdiscuss-greet-f':     `${MP_ANIMATIONS_BASE}/movingdiscuss-greet-f.glb`,
  'movingdiscuss-greet-m':     `${MP_ANIMATIONS_BASE}/movingdiscuss-greet-m.glb`,
  'movingdiscuss-inquire-m':   `${MP_ANIMATIONS_BASE}/movingdiscuss-inquire-m.glb`,
  'movingdiscuss-introduce-f': `${MP_ANIMATIONS_BASE}/movingdiscuss-introduce-f.glb`,
  'movingdiscuss-lookup-f':    `${MP_ANIMATIONS_BASE}/movingdiscuss-lookup-f.glb`,
  'movingdiscuss-lookup-m':    `${MP_ANIMATIONS_BASE}/movingdiscuss-lookup-m.glb`,
  'movingdiscuss-passion-f':   `${MP_ANIMATIONS_BASE}/movingdiscuss-passion-f.glb`,
  'movingdiscuss-passion-m':   `${MP_ANIMATIONS_BASE}/movingdiscuss-passion-m.glb`,
  'movingdiscuss-propose-f':   `${MP_ANIMATIONS_BASE}/movingdiscuss-propose-f.glb`,
  'movingdiscuss-query-m':     `${MP_ANIMATIONS_BASE}/movingdiscuss-query-m.glb`,
  'movingdiscuss-respond-f':   `${MP_ANIMATIONS_BASE}/movingdiscuss-respond-f.glb`,
  'movingdiscuss-response-m':  `${MP_ANIMATIONS_BASE}/movingdiscuss-response-m.glb`,
  'movingtran-accelerate-f':   `${MP_ANIMATIONS_BASE}/movingtran-accelerate-f.glb`,
  'movingtran-accelerate-m':   `${MP_ANIMATIONS_BASE}/movingtran-accelerate-m.glb`,
  'movingtran-decelerate-f':   `${MP_ANIMATIONS_BASE}/movingtran-decelerate-f.glb`,
  'movingtran-decelerate-m':   `${MP_ANIMATIONS_BASE}/movingtran-decelerate-m.glb`,
} as const;

export type MpAnimationKey = keyof typeof MP_ANIMATION_LIBRARY;

/** Chaves dos clipes PARADOS (19) — o pool seguro para as telas atuais. */
export const MP_POOL_STATIONARY = [
  'basic-move-f-idle',
  'basic-move-m-idle-462259',
  'chat-calm-f',
  'chat-cheer-m',
  'chat-listen-f',
  'chat-passion-f',
  'chat-passion-m',
  'chat-propose-m',
  'chat-relax-f',
  'chat-relax-m',
  'chat-response-f',
  'chat-talkandlaugh-f',
  'chat-talkandlaugh-m',
  'discuss-passion-f',
  'discuss-passion-m',
  'discuss-query-m',
  'discuss-respond-f',
  'discuss-whisper-f',
  'discuss-whisper-m',
] as const satisfies readonly MpAnimationKey[];

/** Chaves dos clipes ANDANDO (28) — exigem decisão de root motion + chão. */
export const MP_POOL_LOCOMOTION = [
  'movingchat-lookup-f',
  'movingchat-lookup-m',
  'movingchat-met-f',
  'movingchat-met-m',
  'movingchat-relax-f',
  'movingchat-relax-m',
  'movingchat-strolling-f',
  'movingchat-strolling-m',
  'movingchat-surroundings-f',
  'movingchat-surroundings-m',
  'movingdiscuss-calm-f',
  'movingdiscuss-calm-m',
  'movingdiscuss-greet-f',
  'movingdiscuss-greet-m',
  'movingdiscuss-inquire-m',
  'movingdiscuss-introduce-f',
  'movingdiscuss-lookup-f',
  'movingdiscuss-lookup-m',
  'movingdiscuss-passion-f',
  'movingdiscuss-passion-m',
  'movingdiscuss-propose-f',
  'movingdiscuss-query-m',
  'movingdiscuss-respond-f',
  'movingdiscuss-response-m',
  'movingtran-accelerate-f',
  'movingtran-accelerate-m',
  'movingtran-decelerate-f',
  'movingtran-decelerate-m',
] as const satisfies readonly MpAnimationKey[];

/** Resolve uma chave explícita do acervo ActorCore→MetaPerson preservado. */
export function getMpAnimationUrl(key: MpAnimationKey): string {
  return MP_ANIMATION_LIBRARY[key];
}
